import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {userId} from '/redux/selector/currentUser.selector';
import {
  bonusesLastMonthById,
  bonusesLastMonthDeltaById,
  commissionLastWeekById,
  commissionLastWeekDeltaById,
  incomeLastMonthById,
  incomeLastMonthDeltaById,
} from '/redux/selector/metric.performance.selector';
import {withProps} from '/util/selector.util';

import EarningsSection from './EarningsSection';

const withCurrentUserCoachId = withProps({coachId: userId});

const mapStateToProps = createStructuredSelector({
  commission: withCurrentUserCoachId(commissionLastWeekById),
  commissionDelta: withCurrentUserCoachId(commissionLastWeekDeltaById),
  bonuses: withCurrentUserCoachId(bonusesLastMonthById),
  bonusesDelta: withCurrentUserCoachId(bonusesLastMonthDeltaById),
  totalIncome: withCurrentUserCoachId(incomeLastMonthById),
  totalIncomeDelta: withCurrentUserCoachId(incomeLastMonthDeltaById),
});

export default connect(mapStateToProps)(EarningsSection);
